import { Provider } from '@angular/core';
import { SearchDataHttpService } from './abstract';
import { SearchDataHttpServiceImpl } from './search-data-http.service';

export const SearchDataHttpProvider: Provider = {
	provide: SearchDataHttpService,
	useClass: SearchDataHttpServiceImpl,
};
